<template>
  <div justify="center">
    <v-btn
      color="#033666"
      class="white--text rounded-lg"
      @click.stop="dialog = true"
      dark
      >ขอสิทธิ์ Survey</v-btn
    >
    <v-dialog v-model="dialog" persistent max-width="550px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="pa-0 pt-4 pl-5">
            <span>ขอสิทธิ์ Survey</span>
          </v-card-title>
          <v-card-title class="pa-0 pt-2 pl-5 pb-4">
            <img src="../../assets/img/linemd.png" width="60px" />
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" sm="3">
                  <v-subheader>Survey ID :</v-subheader>
                </v-col>
                <v-col cols="12" sm="9">
                  <v-text-field
                    color="#0D8EEE"
                    outlined
                    dense
                    v-model="surveyrequestform.surveyID"
                    :rules="[
                      $store.getters.TextRule(surveyrequestform.surveyID),
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#033666"
              :disabled="ButtonLoading"
              outlined
              @click="validclose"
            >
              ยกเลิก
            </v-btn>
            <v-btn
              color="#033666"
              :loading="ButtonLoading"
              dark
              @click="RequestSurvey"
            >
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data: () => ({
    dialog: false,
    surveyrequestform: {
      surveyID: "",
    },
  }),
  computed: {
    ButtonLoading() {
      return this.$store.state.button_loading;
    },
  },
  methods: {
    RequestSurvey() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("ReqestSurvey", this.surveyrequestform)
          .then(() => {
            this.dialog = false;
            Swal.fire({
              icon: "success",
              text: "ขอสิทธิ์เรียบร้อยแล้ว กรุณารอการยืนยันจากผู้สร้าง",
              title: "",
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              this.validclose();
            });
          })
          .catch((err) => {
            console.log(err);
            let text = "ไม่สามารถขอได้";
            let icon = "error";
            if (err.data.message === "You Already Own") {
              text = "คุณมีแบบสอบถามนี้อยู่แล้ว";
              icon = "warning";
            } else if (err.data.message === "Waiting for Approve") {
              text = "แบบสอบถามนี้กำลังรออนุมัติ";
              icon = "warning";
            }
            Swal.fire({
              icon: icon,
              text: text,
              title: "",
            });
          });
      }
    },
    validclose() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
